import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUserInfo } from 'redux/userInfo/userInfoSlice';
import { ROUTE_DENIED } from 'constants/routerPath';

// The role group that shows the CANtab. Only Lotus Blossom has it, so every
// other tenant is turned away rather than shown an empty page.
const ACCESS_GROUP_NAME = 'LBW_CANmail_Admin';

interface UserRoleGroup {
	id: string;
	name: string;
}

/**
 * Sends anyone outside the group to the denied page. `allowed` stays false until
 * the user has loaded, so the page renders nothing — and calls nothing — first.
 */
export function useQuantumHealingAccess(): { allowed: boolean } {
	const { userInfo } = useSelector(selectUserInfo);
	const navigate = useNavigate();
	const [allowed, setAllowed] = useState(false);

	useEffect(() => {
		if (!userInfo.contactId) return;

		const isAllowed = Boolean(
			userInfo.userRoleGroups?.some(
				(group: UserRoleGroup) => group?.name === ACCESS_GROUP_NAME
			)
		);

		if (!isAllowed) navigate(ROUTE_DENIED);
		setAllowed(isAllowed);
	}, [navigate, userInfo]);

	return { allowed };
}

export default useQuantumHealingAccess;
